import React, { Suspense } from "react";
import Grid from "@mui/material/Grid2";
import HeaderComponent from "../common/header/HeaderComponent";
import { Outlet } from "react-router-dom";
import { FooterComponent } from "../common/footer/FooterComponent";
import { CircularProgress, Box } from "@mui/material";
import "./DashboardComponent.scss";

interface DashboardComponentProps {
  // Define any props for the component here
}

const DashboardComponent: React.FC<DashboardComponentProps> = (props) => {
  return (
    <div className="dashboard">
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <HeaderComponent />
          <div className="wary-content">
            <Suspense fallback={<Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh"><CircularProgress /></Box>}>
              <Outlet />
            </Suspense>
          </div>
          <FooterComponent variant="dashboard" />
        </Grid>
      </Grid>
    </div>
  );
};

export { DashboardComponent };
